import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

const AddWorkingHrs = (props) => {
  const { showHide, handleShowHide, handleSelect, selectedObj } = props;

  const [hour, setHour] = useState("");
  const [minutes, setMinutes] = useState("");

  useEffect(() => {
    if (selectedObj?.title) {
      const wrkHr = selectedObj.title.toString().split(".");
      setHour(wrkHr[0] ?? "");
      setMinutes(wrkHr[1] ?? "");
    } else {
      setHour("");
      setMinutes("");
    }
  }, [selectedObj]);

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = date instanceof Date ? date : new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return "Invalid Date";
  };

  const doSubmit = () => {
    const hrNum = hour === "" ? 0 : Number(hour);
    const minStr = minutes === "" ? "0" : minutes.toString();
    let wrkHr;

    if (hrNum === 24) {
      wrkHr = "24.0";
    } else if (minStr && minStr !== "0") {
      wrkHr = `${hrNum}.${minStr}`;
    } else {
      wrkHr = hrNum;
    }

    handleSelect(wrkHr);
  };

  const hrNum = hour === "" ? 0 : Number(hour);
  const minNum = minutes === "" ? 0 : Number(minutes);

  const bothEmpty = hour === "" && minutes === "";
  const zeroZero = hrNum === 0 && minNum === 0;
  const outOfRange = hrNum < 0 || hrNum > 24 || minNum < 0 || minNum > 59;
  const twentyFourInvalid = hrNum === 24 && minNum !== 0;

  const isInvalid = bothEmpty || zeroZero || outOfRange || twentyFourInvalid;
  const summaryValue =
    hrNum === 24
      ? "24h 0m"
      : `${hour === "" ? 0 : hrNum}h ${minutes === "" ? 0 : minNum}m`;

  return (
    <>
      <style>{`
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-hours-modal.modal-dialog {
          transform: scale(0.96) !important;
          transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-hours-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-hours-modal {
          max-width: 560px !important;
          width: 95% !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .wf-hours-modal .modal-content {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-hours-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 14px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-hours-modal .modal-header::before {
          display: none !important;
        }

        .wf-hours-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          width: 100% !important;
        }

        .wf-hours-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          width: 100% !important;
        }

        .wf-hours-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-hours-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }

        .wf-hours-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 17px !important;
          font-weight: 600 !important;
          line-height: 1.25 !important;
        }

        .wf-hours-modal .rt-header-icon {
          width: 38px !important;
          height: 38px !important;
          min-height: 38px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
        }

        .wf-hours-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
        }

        .wf-hours-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }

        .wf-hours-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }

        .wf-hours-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          outline: none !important;
        }
        .wf-hours-modal .rt-action-btn:hover {
          color: #ef4444 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .wf-hours-modal .modal-body {
          padding: 20px 24px !important;
          background: #ffffff !important;
          max-height: calc(90vh - 140px) !important;
          overflow-y: auto !important;
        }

        /* Body Custom Classes */
        .wf-hours-modal .wf-helper-card {
          border-radius: 0 !important;
          padding: 12px 14px !important;
          background: #eff6ff !important;
          border: 1px solid #bfdbfe !important;
          margin-bottom: 16px !important;
        }
        .wf-hours-modal .wf-helper-title {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #1e40af !important;
          margin-bottom: 3px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
        }
        .wf-hours-modal .wf-helper-text {
          font-size: 12px !important;
          line-height: 1.5 !important;
          color: #1d4ed8 !important;
          margin: 0 !important;
        }
        
        .wf-hours-modal .wf-input-card {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          padding: 14px !important;
          height: 100% !important;
        }
        .wf-hours-modal .wf-input-label {
          font-size: 11.5px !important;
          font-weight: 700 !important;
          letter-spacing: 0.04em !important;
          text-transform: uppercase !important;
          color: #334155 !important;
          margin-bottom: 4px !important;
          display: block !important;
        }
        .wf-hours-modal .wf-input-hint {
          font-size: 11.5px !important;
          color: #64748b !important;
          margin-bottom: 10px !important;
          line-height: 1.4 !important;
        }
        .wf-hours-modal .wf-input-shell {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          height: 38px !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          padding: 6px 12px !important;
          outline: none !important;
          width: 100% !important;
        }
        .wf-hours-modal .wf-input-shell:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }

        .wf-hours-modal .wf-summary-bar {
          margin-top: 14px !important;
          padding: 10px 14px !important;
          border-radius: 0 !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          font-size: 13px !important;
          color: #334155 !important;
          font-weight: 600 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
        }
        .wf-hours-modal .wf-warning-bar {
          margin-top: 12px !important;
          padding: 10px 14px !important;
          border-radius: 0 !important;
          background: #fffbeb !important;
          border: 1px solid #fde68a !important;
          font-size: 12px !important;
          line-height: 1.5 !important;
          color: #92400e !important;
          font-weight: 500 !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
        }

        /* Modal Footer */
        .wf-hours-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 14px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }

        .wf-hours-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 14px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-hours-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
        }

        .wf-hours-modal .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 7px 16px !important;
          border-radius: 0 !important;
          border: 1px solid #2563eb !important;
          background: #2563eb !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-hours-modal .wf-btn-save:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .wf-hours-modal .wf-btn-save:active {
          transform: scale(0.97) !important;
        }
        .wf-hours-modal .wf-btn-save:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
`}</style>
      <Modal
        show={showHide}
        dialogClassName="wf-hours-modal"
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-clock-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Add/Edit Hours and Minutes</span>
                      <span className="rt-modal-title-badge">Entry</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">{formatDate(selectedObj?.start)}</span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleShowHide("")}
                aria-label="Close working hours popup"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="wf-helper-card">
            <div className="wf-helper-title">Quick tip</div>
            <p className="wf-helper-text">
              Use hours and minutes for the selected day. If you enter `24` hours,
              minutes are locked to `0` automatically.
            </p>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="wf-input-card">
                <label htmlFor="hour" className="wf-input-label">
                  Enter Hour
                </label>
                <div className="wf-input-hint">
                  Allowed range is 0 to 24 hours.
                </div>
                <input
                  type="number"
                  id="hour"
                  name="hour"
                  className="form-control wf-input-shell"
                  placeholder="Enter Hour"
                  value={hour}
                  onChange={({ currentTarget }) => {
                    let val = currentTarget.value;
                    if (val === "") {
                      setHour("");
                      return;
                    }
                    const n = Number(val);
                    if (isNaN(n)) return;
                    if (n < 0) val = "0";
                    if (n > 24) val = "24";
                    setHour(val);
                    if (val === "24") {
                      setMinutes("0");
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="wf-input-card">
                <label
                  htmlFor="minutes"
                  className="wf-input-label"
                >
                  Enter Minutes
                </label>
                <div className="wf-input-hint">
                  Allowed range is 0 to 59 minutes.
                </div>
                <input
                  type="number"
                  id="minutes"
                  name="minutes"
                  className="form-control wf-input-shell"
                  placeholder="Enter Minutes"
                  value={hour === "24" ? "0" : minutes}
                  disabled={hour === "24"}
                  onChange={({ currentTarget }) => {
                    let val = currentTarget.value;
                    if (val === "") {
                      setMinutes("");
                      return;
                    }
                    const n = Number(val);
                    if (isNaN(n)) return;
                    if (n < 0) val = "0";
                    if (n > 59) val = "59";
                    setMinutes(val);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="wf-summary-bar"><span>Selected duration:</span><span style={{ color: "#2563eb", fontWeight: 700 }}>{summaryValue}</span></div>
          {isInvalid && (
            <div className="wf-warning-bar"><i className="fa fa-exclamation-circle" style={{ color: "#d97706", fontSize: "14px" }} /><span>Enter a valid time greater than <strong>0h 0m</strong>. Minutes must stay between 0-59, and 24 hours only works with 0 minutes.</span></div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
          <button
            type="button"
            className="wf-btn-save"
            disabled={isInvalid}
            onClick={doSubmit}
          >
            <i className="fa fa-check" aria-hidden="true"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddWorkingHrs;
